<template>
  <div class="list-line">
    <div class="list-line__title">
      <component :is="data.leftIcon" class="list-line__icon" />
    </div>
    <div class="list-line__text">{{ data.hasAutoComplete ? `${translateText('hubstr.editor.phone_preview.text')} 1, ${translateText('hubstr.editor.phone_preview.text')} 2` : translateText('hubstr.editor.phone_preview.text') }}</div>
  </div>
  <el-divider />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { AdditionalField, ListLineRawActionWidget } from 'features/settings/mobile-editor/interfaces';
import { AdditionsList } from 'features/settings/mobile-editor/requests';
import { translate, useTranslate } from 'magner';
import People from '../../../assets/icons/people.svg';
import Peoples from '../../../assets/icons/peoples.svg';
import Pie_chart from '../../../assets/icons/pie_chart.svg';
import Suitcase from '../../../assets/icons/suitcase.svg';
import Folder from '../../../assets/icons/folder.svg';
import Folder_full from '../../../assets/icons/folder_full.svg';

export default defineComponent({
  name: 'ListLineRawAction',
  components: {
    People,
    Peoples,
    Pie_chart,
    Suitcase,
    Folder,
    Folder_full,
  },
  props: {
    data: {
      type: Object as PropType<ListLineRawActionWidget>,
      required: true,
    },
  },
  setup (props) {
    const matchingField = Object.values(AdditionsList).find((field) => Object.keys(props.data).some((key) => {
      if (props.data[key] && typeof props.data[key] === 'string') {
        return props.data[key] === field.formCode;
      }
    })) as AdditionalField;

    const { customT } = useTranslate();
    const translateText = (code: string) => customT(translate(code));

    return {
      matchingField,
      translateText,
    };
  },
});
</script>

<style lang="scss" scoped>
.list-line {
  display: flex;
  align-items: center;
  &__title {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  &__icon {
    width: 20px;
    margin-right: 10px;
  }
}
.el-divider--horizontal {
  margin: 15px 0 15px 0;
}
</style>
